var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: "20px",
            visible: _vm.visiable,
            width: "1496px",
            title: "中成药",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visiable = $event
            },
            open: _vm.handleShow,
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "title-con pb-10 flex flex-row align-center",
                    },
                    [
                      _c("span", { staticClass: "title mr-10" }, [
                        _vm._v("中成药"),
                      ]),
                      _c("span", { staticClass: "sub-title self-end" }, [
                        _c("img", {
                          staticClass: "warning-icon",
                          attrs: {
                            alt: "warning",
                            src: require("@/assets/tcm/Vector.png"),
                          },
                        }),
                        _vm._v(
                          " 处方由 AI 匹配生成，内容仅供参考，请医疗人员结合患者实际病情酌情选择和使用。 "
                        ),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "tcm-list-con flex flex-row",
              staticStyle: { "min-height": "500px" },
            },
            _vm._l(_vm.data, function (item) {
              return _c("Tcm", {
                key: item.id,
                staticClass: "tcm",
                attrs: { row: item },
                on: { choose: _vm.handleRowClick, detail: _vm.handleDetail },
              })
            }),
            1
          ),
        ]
      ),
      _c(
        "el-button",
        {
          staticClass: "ik-user-btn",
          attrs: { size: "mini", type: "primary" },
          on: { click: _vm.handleOpen },
        },
        [_vm._t("default")],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "详情", visible: _vm.detailVisiable },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisiable = $event
            },
          },
        },
        [_c("TcmDetail", { attrs: { row: _vm.detail } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }